import {
  FETCH_MULTICONTRACT_RELATIONS,
  FETCH_MULTICONTRACT_RELATIONS_SUCCESS,
  FETCH_MULTICONTRACT_RELATIONS_FAILURE,
  CREATE_MULTICONTRACT_RELATION,
  CREATE_MULTICONTRACT_RELATION_SUCCESS,
  CREATE_MULTICONTRACT_RELATION_FAILURE,
  SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_SUCCESS
} from './actions';
import _ from 'lodash';

_.mixin({
  mapKeysDeep(obj, fn) {
    const result = {};
    _.forOwn(obj, (v, k) => {
      if (_.isPlainObject(v)) {
        v = _.mapKeysDeep(v, fn);
      }
      result[fn(v, k)] = v;
    });
    return result;
  }
});

const DEFAULT_STATE = {
  newMultiContractOrgRelations: [],
  errors:                       [],
  notice:                       '',
  isCreating:                   false,
  isSearching:                  false,
  isUpdating:                   false,
  isImporting:                  false
};


export const extractErrors = res => _.chain(res)
  .get('response.errors')
  .values()
  .flatten()
  .value();

export const mcorReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    // create
    case CREATE_MULTICONTRACT_RELATION: {
      return {
        ...state,
        isCreating: true
      };
    }
    case CREATE_MULTICONTRACT_RELATION_SUCCESS: {
      const mcor = action.payload.response;
      return {
        ...state,
        errors:                       [],
        notice:                       action.payload.response.notice,
        newMultiContractOrgRelations: [mcor, ...state.newMultiContractOrgRelations],
        isCreating:                   false
      };
    }
    case CREATE_MULTICONTRACT_RELATION_FAILURE: {
      return {
        ...state,
        errors:     action.payload,
        notice:     '',
        isCreating: false
      };
    }
    case FETCH_MULTICONTRACT_RELATIONS: {
      return {
        ...state,
        isSearching: true
      };
    }
    case FETCH_MULTICONTRACT_RELATIONS_SUCCESS: {
      return {
        ...state,
        errors:                      [],
        notice:                      _.get(action, 'payload.response.notice'),
        multiContractGroupRelations: action.payload,
        isSearching:                 false
      };
    }
    case FETCH_MULTICONTRACT_RELATIONS_FAILURE: {
      return {
        ...state,
        errors:      action.payload,
        notice:      '',
        isSearching: false
      };
    }
    case SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS_SUCCESS: {
      const result =  {
        ...state,
        notice:      '',
        isSearching: false
      };
      result[action.orgSide] = action.payload.benefitSponsorContractOrgRelations;
      return result;
    }
    default: {
      return state;
    }
  }
};
